import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Context = /*#__PURE__*/createContext(null);
export function useUserDetails() {
  return useContext(Context);
}
export function UserDetailsProvider({
  children,
  user
}) {
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: user,
    "data-sentry-element": "unknown",
    "data-sentry-component": "UserDetailsProvider",
    "data-sentry-source-file": "UserDetailsProvider.tsx",
    children: children
  });
}